"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseContextProvider = exports.BaseContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _HttpStatus = require("../constants/HttpStatus");
var _DmsFetch = require("../components/DmsFetch/DmsFetch");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BaseContext = exports.BaseContext = /*#__PURE__*/(0, _react.createContext)();
const BaseContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [whoamiReply, setWhoamiReply] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const get_whoami_reply = async () => {
      await (0, _DmsFetch.fetchData)('/whoami/reply', 'GET', true).then(response => {
        if (response.status === _HttpStatus.HTTP_STATUS.OK_200) {
          setWhoamiReply(response.data);
        } else {
          console.error(response);
        }
      });
    };
    get_whoami_reply();
  }, []);
  return /*#__PURE__*/_react.default.createElement(BaseContext.Provider, {
    value: {
      whoamiReply
    }
  }, children);
};
exports.BaseContextProvider = BaseContextProvider;